import React, { useContext } from 'react';

import styled from '@emotion/styled';

import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import ModalContainer from '../../ModalContainer';
import { ModalContext } from '../../ModalContext';

interface SaveContactModalProps {
  msg: string;
  loading?: boolean;
  onConfirmFn: (callbackFn: () => void) => void;
}

const SaveContactModal: React.FC<SaveContactModalProps> = ({
  msg,
  loading,
  onConfirmFn,
}) => {
  const modalContext = useContext(ModalContext);

  return (
    <Container>
      <ModalContainer
        label='Contact Permission'
        showSuccessComponent={modalContext?.showSuccessComponent}
      >
        <Description>{msg}</Description>
        <ButtonArea>
          <FormSubmitButton
            className='clear fill'
            btnType='button'
            onClick={() => modalContext?.setShowModal(false)}
          >
            Cancel
          </FormSubmitButton>

          <FormSubmitButton
            loading={loading}
            btnType='button'
            onClick={() => {
              onConfirmFn(() => {
                modalContext?.setShowModal(false);
              });
            }}
            className='fill'
          >
            Save
          </FormSubmitButton>
        </ButtonArea>
      </ModalContainer>
    </Container>
  );
};

export default SaveContactModal;

const Container = styled.div`
  flex-direction: column;
  gap: 12px;
  display: flex;
`;

const ButtonArea = styled.div`
  display: flex;
  width: 100%;
  gap: 16px;
  /* margin-left: auto; */
`;

const Description = styled.div`
  margin-bottom: 16px;
  color: ${({ theme }) => theme.palette.grayTextColor};
  font-size: 14px;
`;
